<template>
  <div class="updatecost-container">
    <div class="dialog-main add-dialog">
      <el-form label-position="right" label-width="120px" :rules="rules" ref="updateForm" :model="updateForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="成本(元)：" prop="costAmountStr">
              <el-input v-model="updateForm.costAmountStr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产生日期：" prop="costDate">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="updateForm.costDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成本类型：" prop="costType">
              <el-select v-model="updateForm.costType">
                <el-option
                  v-for="item in compactCostType.results"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款方：" prop="payee">
              <el-input v-model="updateForm.payee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                placeholder="不超过200字"
                :rows="4"
                v-model="updateForm.remarks"
                name="remarks">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="handleClose">
      </crm-button>
      <crm-button :text="'保存'" @click="handleSave" :disabled="isSubmitDisabled"></crm-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import crmButton from '@/components/base/crmButton';

export default {
  props: {
    costDetail: {
      type: Object,
    },
  },
  components: {
    crmButton,
  },
  data() {
    const totalMoneyRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入成本'));
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 9999999.99) {
        callback(new Error('最大9999999.99'));
      } else {
        callback();
      }
    };
    return {
      updateForm: {},
      rules: {
        costAmountStr: [
          { required: true, validator: totalMoneyRule, trigger: 'blur' },
        ],
        costDate: [
          { required: true, message: '请选择产生日期', trigger: 'change' },
        ],
        costType: [
          { required: true, message: '请选择成本类型', trigger: 'change' },
        ],
        payee: [
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        remarks: [
          { max: 200, message: '不超过200个字', trigger: 'blur' },
        ],
      },
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      compactCostType: 'compact/compactCostType',
    }),
  },
  created() {
    this.getCostType({
      code: 'category_cost_type',
    });
    this.initUpdateForm();
  },
  methods: {
    ...mapActions({
      getCostType: 'compact/getCostType',
      saveUpdateCompactCost: 'compact/saveUpdateCompactCost',
    }),
    initUpdateForm() {
      this.updateForm = {
        id: this.costDetail.id,
        costAmountStr: this.costDetail.costAmountStr,
        costDate: this.costDetail.costDate,
        costType: this.costDetail.costType,
        payee: this.costDetail.payee,
        remarks: this.costDetail.remarks,
      };
    },
    handleClose() {
      this.$emit('close');
    },
    handleSave() {
      this.$refs.updateForm.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          this.saveUpdateCompactCost(this.updateForm).then(() => {
            this.$message({
              type: 'success',
              message: '修改成本成功',
            });
            this.$emit('close');
            this.$emit('success');
            this.initUpdateForm();
          }).finally(() => {
            this.isSubmitDisabled = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.updatecost-container {
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
}
</style>
